import React from 'react';

const SelectInput = props => {
  // Props
  const {
    label,
    type,
    options,
    defaultValue,
    name,
    register,
    errors,
    ...rest
  } = props;

  // Render
  return (
    <div>
      <label
        htmlFor={name}
        className="block text-sm font-medium  dark:text-gray-200"
      >
        {label || 'Select Input'}
      </label>
      <select
        {...rest}
        {...register(name)}
        className={`w-full mt-1 form-select placeholder:text-sm dark:placeholder:text-gray-400 ${
          errors
            ? 'border-red-500 focus:ring-red-500 dark:border-red-600 dark:focus:ring-red-600'
            : ''
        }`}
      >
        {options.map(option => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
      {errors && <p className="mt-2 text-xs text-red-500">{errors}</p>}
    </div>
  );
};

export default SelectInput;
